import { render, staticRenderFns } from "./ListAgroServices.vue?vue&type=template&id=747f6c01"
import script from "./ListAgroServices.vue?vue&type=script&lang=js"
export * from "./ListAgroServices.vue?vue&type=script&lang=js"
import style0 from "./ListAgroServices.vue?vue&type=style&index=0&id=747f6c01&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports